import { Tooltip } from 'bootstrap';
import { useEffect } from 'react';

const useTooltips = () => {
    useEffect(() => {
        setTimeout(() => {
            const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl);
            });
        }, 1000);
    }, []);
};

export default useTooltips;